"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.timeSelectorNeoDark = exports.timeSelectorNeoLight = exports.timeSelectorNovoDark = exports.timeSelectorNovo = exports.timeSelector = void 0;
const polished_1 = require("polished");
const oxygen_theme_1 = __importDefault(require("@8x8/oxygen-theme"));
const input_const_1 = require("./input.const");
const zIndex_const_1 = __importDefault(require("../choices/zIndex.const"));
const timing_const_1 = __importDefault(require("../choices/timing.const"));
const size_const_1 = __importDefault(require("../choices/size.const"));
const color_const_1 = __importDefault(require("../choices/color.const"));
const spacing_const_1 = __importDefault(require("../choices/spacing.const"));
const font_const_1 = __importDefault(require("../choices/font.const"));
const { light, dark, neoLight, neoDark } = oxygen_theme_1.default;
const timeSelector = {
    input: input_const_1.input,
    dropdownAnimationDuration: timing_const_1.default.fast,
    dropdownZIndex: zIndex_const_1.default.z3000,
    dropdownBorderSize: size_const_1.default.borderSizeDefault,
    dropdownBorderColor: color_const_1.default.cloudyBlue300,
    dropdownBorderRadius: 0,
    dropdownShadowBlurRadius: size_const_1.default.small,
    dropdownShadowColor: (0, polished_1.rgba)(color_const_1.default.cloudyBlue300, 0.6),
    dropdownShadow: undefined,
    dropdownFontSize: font_const_1.default.sizeSm,
    dropdownLineHeight: font_const_1.default.lineHeightSm,
    dropdownFontFamily: font_const_1.default.family,
    dropdownWidth: '140px',
    dropdownMaxHeight: '160px',
    dropdownPadding: '0px',
    listItemPadding: `${spacing_const_1.default.xxs} ${spacing_const_1.default.xs}`,
    listItemBackground: color_const_1.default.white,
    listItemBackgroundHover: color_const_1.default.cloudyBlue100,
    listItemBackgroundSelected: color_const_1.default.dodgerBlue100,
    listItemColor: color_const_1.default.pickledBluewood,
};
exports.timeSelector = timeSelector;
const timeSelectorNovo = {
    input: input_const_1.inputNovo,
    dropdownAnimationDuration: '150ms',
    dropdownZIndex: zIndex_const_1.default.z3000,
    dropdownBorderSize: '1px',
    dropdownBorderColor: light.ui01,
    dropdownBorderRadius: '6px',
    dropdownShadowBlurRadius: undefined,
    dropdownShadowColor: undefined,
    dropdownShadow: `0px 1px 2px ${(0, polished_1.rgba)(light.ui04, 0.25)}`,
    dropdownFontSize: light.body02.fontSize,
    dropdownLineHeight: light.body02.lineHeight,
    dropdownFontFamily: light.body02.fontFamily,
    dropdownWidth: '160px',
    dropdownMaxHeight: '160px',
    dropdownPadding: `${light.spacing03} 0`,
    listItemPadding: '9px 15px',
    listItemBackground: light.ui06,
    listItemBackgroundHover: light.hover08,
    listItemBackgroundSelected: light.hover08,
    listItemColor: light.textColor01,
};
exports.timeSelectorNovo = timeSelectorNovo;
const timeSelectorNovoDark = {
    ...timeSelectorNovo,
    input: input_const_1.inputNovoDark,
    dropdownBorderColor: dark.ui01,
    dropdownShadow: `0px 1px 2px ${(0, polished_1.rgba)(dark.ui04, 0.25)}`,
    listItemBackground: dark.ui06,
    listItemBackgroundHover: dark.hover08,
    listItemBackgroundSelected: dark.hover08,
    listItemColor: dark.textColor01,
};
exports.timeSelectorNovoDark = timeSelectorNovoDark;
const timeSelectorNeoLight = {
    ...timeSelectorNovo,
    input: input_const_1.inputNeoLight,
    dropdownBorderColor: neoLight.ui01,
    dropdownShadow: `0px 1px 2px ${(0, polished_1.rgba)(neoLight.ui04, 0.25)}`,
    listItemBackground: neoLight.ui06,
    listItemBackgroundHover: neoLight.hover08,
    listItemBackgroundSelected: neoLight.hover08,
    listItemColor: neoLight.textColor01,
};
exports.timeSelectorNeoLight = timeSelectorNeoLight;
const timeSelectorNeoDark = {
    ...timeSelectorNovoDark,
    input: input_const_1.inputNeoDark,
    dropdownBorderColor: neoDark.ui01,
    dropdownShadow: `0px 1px 2px ${(0, polished_1.rgba)(neoDark.ui04, 0.25)}`,
    listItemBackground: neoDark.ui06,
    listItemBackgroundHover: neoDark.hover08,
    listItemBackgroundSelected: neoDark.hover08,
    listItemColor: neoDark.textColor01,
};
exports.timeSelectorNeoDark = timeSelectorNeoDark;
